module.exports = __webpack_public_path__ + "img/21.f451fc09.png";